import React, { useEffect, useState } from "react";
import API from "../api";
import { Container } from "react-bootstrap";

export default function VisiMisi() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await API.get("/content");
        setData(res.data || []);
      } catch (err) {
        console.error("Error load visi & misi:", err);
      }
    };

    load();
  }, []);

  // Ambil semua visi & misi
  const visiItems = data.filter(d => d.type === "visi");
  const misiItems = data.filter(d => d.type === "misi");

  return (
    <Container className="mt-4">

      <h1 className="text-center mb-4">
        🌈 Visi & Misi PAUD KB Cahaya Piradita Kaning
      </h1>

      {/* VISI */}
      <div className="card-visi mb-4">
        <h3>🌟 Visi</h3>
        {visiItems.length === 0 ? (
          <p>Belum ada data visi</p>
        ) : (
          visiItems.map(v => <p key={v.id}>{v.description}</p>)
        )}
      </div>

      {/* MISI */}
      <div className="card-misi">
        <h3>🎯 Misi</h3>
        {misiItems.length === 0 ? (
          <p>Belum ada data misi</p>
        ) : (
          misiItems.map(m => <p key={m.id}>{m.description}</p>)
        )}
      </div>

    </Container>
  );
}